//
import React from "react";

const ArrowRight = () => {

    return <svg width="21" height="8" viewBox="0 0 21 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.3616 4.35356C20.557 4.15829 20.5572 3.84171 20.3621 3.64645L17.1822 0.464468C16.9871 0.269206 16.6705 0.269206 16.4751 0.464468C16.2797 0.659731 16.2795 0.976313 16.4747 1.17158L19.3012 4L16.4709 6.82843C16.2755 7.02369 16.2753 7.34027 16.4704 7.53553C16.6655 7.7308 16.9821 7.7308 17.1775 7.53553L20.3616 4.35356ZM0.00796665 4.5L20.008 4.5L20.0086 3.5L0.00863491 3.5L0.00796665 4.5Z" fill="currentColor"/>
    </svg>

}

export default ArrowRight;
